import { Spinner } from 'react-bootstrap';

function PageLoader() {
  return (
    <div className="d-flex align-items-center justify-content-center p-5">
      <Spinner animation="border" />
    </div>
  );
}

export default PageLoader;
